import React from 'react';
import { observer, inject } from 'mobx-react';
import { withNamespaces } from 'react-i18next';
import PropTypes from 'prop-types';

import { CardSection } from 'legacyComponents/layout/cardSection';
import { ProjectCard } from 'legacyComponents/cards/types/project';

@withNamespaces()
@inject('routerStore')
@observer
export class Channel extends React.Component {
  render() {
    const { projects } = this.props;

    return (
      <CardSection
        title='Projects'
        tooltip='Create new project'
        updateHeader
        index={1}
        isChannel
        ownerName=''
        cardApp={projects}
        CardComponent={ProjectCard}
        noDataCardType='project'
        gridColumns={3}
        noCount
      />
    );
  }
}

Channel.propTypes = {
  projects: PropTypes.object,
};
